module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Zulu.html",
      "xml:lang": "en-GB",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("Be the tiny blade upon the grass:"), _c('br'), _vm._v("\n      greater than the spindle of the whole world’s mass . . ."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—ATTILA JÓZSEF"), _c('br')]), _vm._v(" (translated by Zsuzsanna Ozsváth"), _c('br'), _vm._v("\n      and Frederick Turner)"), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f4ee624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Zulu.vue
// module id = 66
// module chunks = 0